import { useRef, type PointerEventHandler } from "react";
import { aboutTeam, teamSectionOverview } from "../../content/siteContent";
import { sectionEntryConfigs } from "../../lib/sectionEntry";
import { useAppStore } from "../../store/useAppStore";
import { useSectionEntryStore } from "../../store/useSectionEntryStore";
import { getTeamActiveMemberIndex } from "../../webgl/sections/teamScenePhase";

export function TeamSection() {
  const sectionRef = useRef<HTMLElement | null>(null);
  const teamEntryState = useSectionEntryStore((state) => state.sections.team);
  const phase = teamEntryState.phase;
  const setTeamHovered = useAppStore((state) => state.setTeamHovered);
  const setTeamPointer = useAppStore((state) => state.setTeamPointer);
  const initialMemberIndex = sectionEntryConfigs.team?.initialStateIndex ?? 0;
  const activeMemberIndex = getTeamActiveMemberIndex(teamEntryState.browseProgress, aboutTeam.length, initialMemberIndex);
  const activeMember = aboutTeam[activeMemberIndex] ?? aboutTeam[0];

  const handlePointerMove: PointerEventHandler<HTMLElement> = (event) => {
    const bounds = event.currentTarget.getBoundingClientRect();
    const x = bounds.width > 0 ? ((event.clientX - bounds.left) / bounds.width) * 2 - 1 : 0;
    const y = bounds.height > 0 ? ((event.clientY - bounds.top) / bounds.height) * 2 - 1 : 0;

    setTeamPointer({
      x: Math.min(Math.max(x, -1), 1),
      y: Math.min(Math.max(y, -1), 1)
    });
  };

  return (
    <section
      className="experience-section experience-section--team"
      data-entry-phase={phase}
      onMouseEnter={() => setTeamHovered(true)}
      onMouseLeave={() => {
        setTeamHovered(false);
        setTeamPointer({ x: 0, y: 0 });
      }}
      onPointerMove={handlePointerMove}
      ref={sectionRef}
    >
      <div className="team-page">
        {/* <header className="team-page__hero">
          <p aria-hidden="true" className="team-page__word">
            TEAM
          </p>
          <div aria-hidden="true" className="team-page__stage" />
        </header> */}

        {/* <div className="team-page__mobilePanel" aria-hidden="false">
          <p className="team-page__mobileEyebrow">{teamSectionOverview.eyebrow}</p>
          <div className="team-page__mobileHeader">
            <div>
              <p className="team-page__mobileName">{activeMember.name}</p>
              <h2 className="team-page__mobileRole">{activeMember.role}</h2>
            </div>
            <p className="team-page__mobileCounter">
              {String(activeMemberIndex + 1).padStart(2, "0")} / {String(aboutTeam.length).padStart(2, "0")}
            </p>
          </div>
          <p className="team-page__mobileBody">{activeMember.body}</p>
        </div> */}

        {/* <div className="sr-only">
          <p>{teamSectionOverview.eyebrow}</p>
          <h2>{teamSectionOverview.title}</h2>
          <p>{teamSectionOverview.intro}</p>
          <ul>
            {aboutTeam.map((member) => (
              <li key={member.name}>
                <strong>{member.name}</strong>
                <span>{member.role}</span>
                <p>{member.body}</p>
              </li>
            ))}
          </ul>
        </div> */}
      </div>
    </section>
  );
}
